module.exports = __webpack_public_path__ + "static/media/usdc-color.b44c4c58.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/usdc-color.svg
// module id = 2390
// module chunks = 7